import { getDOMElement } from './utils';
import { Player } from './player';
declare var WebTransport: any;

const MESSAGE_UNSUPPORTED_BROWSER = 'Not yet supported by this browser.';

export function setupDemoApp() {
  // Attempt to get DOM elements
  const h3ServerSelectEl = getDOMElement<HTMLSelectElement>('h3-server-select');
  const customHostInputEl = getDOMElement<HTMLInputElement>('custom-host-input');
  const streamInputEl = getDOMElement<HTMLInputElement>('stream-input');

  const volumeInputEl = getDOMElement<HTMLInputElement>('volume-fader');
  const volumeOutputEl = getDOMElement<HTMLOutputElement>('volume');

  const serverUrls: { [key: string]: string } = {
    origin: 'https://t2devteam-edge-eu-vu-ams-01.nanocosmos.de:4433/h5live/stream/stream.mp4',
    edge1: 'https://t2devteam-edge-eu-vu-ams-01.nanocosmos.de:4443/h5live/stream/stream.mp4',
    edge2: 'https://t2devteam-edge-ass-vu-sgp-01.nanocosmos.de:4443/h5live/stream/stream.mp4',
    localhostOrigin: 'https://localhost:4433/h5live/stream/stream.mp4',
    localhostEdge: 'https://localhost:4443/h5live/stream/stream.mp4',
  };

  const windowUrl = new URL(window.location.toString());
  const streamParam = windowUrl.searchParams.get('stream');
  const h3UrlParam = windowUrl.searchParams.get('h3Url');

  const isIndexPage = h3ServerSelectEl && customHostInputEl && streamInputEl;

  if (isIndexPage) {
    // ** Logic for index.html **
    h3ServerSelectEl.addEventListener('change', () => {
      if (h3ServerSelectEl.value === 'custom') {
        customHostInputEl.style.display = 'inline';
      } else {
        customHostInputEl.style.display = 'none';
      }
    });

    if (h3UrlParam) {
      try {
        const decodedH3Url = decodeURIComponent(h3UrlParam);
        new URL(decodedH3Url); // This will throw if invalid

        h3ServerSelectEl.value = 'custom';
        customHostInputEl.value = decodedH3Url;
        customHostInputEl.style.display = 'inline';
        h3ServerSelectEl.disabled = true;
        streamInputEl.disabled = true;

        const h3Url = new URL(decodedH3Url);
        const embeddedStreamParam = h3Url.searchParams.get('stream');
        if (embeddedStreamParam) {
          streamInputEl.value = embeddedStreamParam;
          h3Url.searchParams.delete('stream');
          customHostInputEl.value = h3Url.toString();
        }
      } catch (error) {
        console.error('Invalid h3Url parameter:', error);
        if (streamParam) {
          streamInputEl.value = streamParam;
          h3ServerSelectEl.value = 'localhostOrigin';
          customHostInputEl.style.display = 'none';
        } else {
          h3ServerSelectEl.value = 'localhostOrigin';
          customHostInputEl.style.display = 'none';
        }
      }
    } else if (streamParam) {
      streamInputEl.value = streamParam;
      h3ServerSelectEl.value = 'localhostOrigin';
      customHostInputEl.style.display = 'none';
    } else {
      h3ServerSelectEl.value = 'localhostOrigin';
      customHostInputEl.style.display = 'none';
    }
  } else {
    // ** Logic for demo.html **

    let urlToPlay = 'https://t2devteam-edge-eu-vu-ams-01.nanocosmos.de:4433/h5live/stream/stream.mp4';
    if (h3UrlParam) {
      try {
        const decodedH3Url = decodeURIComponent(h3UrlParam);
        const h3Url = new URL(decodedH3Url);

        const embeddedStreamParam = h3Url.searchParams.get('stream');
        if (embeddedStreamParam) {
          urlToPlay = h3Url.toString();
        } else if (streamParam) {
          h3Url.searchParams.append('stream', streamParam);
          urlToPlay = h3Url.toString();
        } else {
          urlToPlay = h3Url.toString();
        }
      } catch (error) {
        console.error('Invalid h3Url parameter:', error);
        if (streamParam) {
          urlToPlay = serverUrls['origin'] + '?stream=' + encodeURIComponent(streamParam);
        } else {
          urlToPlay = serverUrls['origin'] + '?stream=HX26g-Y65TP';
        }
      }
    } else if (streamParam) {
      urlToPlay = serverUrls['origin'] + '?stream=' + encodeURIComponent(streamParam);
    } else {
      urlToPlay = serverUrls['origin'] + '?stream=HX26g-Y65TP';
    }

    var demoPageUrlToPlay = urlToPlay;
  }

  const canvasEl = document.querySelector('canvas');
  if (!canvasEl) {
    throw new Error('Could not find canvas element in dom');
  }

  (canvasEl as HTMLCanvasElement).width = 640;
  (canvasEl as HTMLCanvasElement).height = 360;

  const posterImage = new Image();
  posterImage.src = 'https://www.nanocosmos.de/blog/wp-content/uploads/2023/08/poster-player-demo-23.png';
  posterImage.onload = () => {
    const canvasCtx = (canvasEl as HTMLCanvasElement).getContext('2d');
    if (!canvasCtx) {
      throw new Error('Could not get canvas drawing context');
    }
    canvasCtx.drawImage(posterImage, 0, 0, canvasEl.width, canvasEl.height);
  };

  if (!checkSupportedTechs()) {
    const playerContainer = getDOMElement<HTMLElement>('player-container');
    const subtitleContainer = getDOMElement<HTMLElement>('subtitle-container');
    const subtitleEl = getDOMElement<HTMLElement>('subtitle');

    if (playerContainer) {
      playerContainer.style.display = 'none';
    }
    if (subtitleContainer) {
      subtitleContainer.style.display = 'block';
    }
    if (subtitleEl) {
      subtitleEl.innerText = MESSAGE_UNSUPPORTED_BROWSER;
    }
    return;
  }

  const player = new Player();

  player.on('timeupdate', () => {});

  player.on('stats', (reset: boolean) => {
    onStatsUpdate(reset);
  });

  player.on('error', (msg: string, err: Error) => {
    console.error('Player error:', msg, err);
  });

  setVolume(50);

  function onStatsUpdate(reset: boolean) {
    if (!player) return;
    try {
      const statsTableBody = document.querySelector('#stats-table tbody');
      if (!statsTableBody) {
        return;
      }

      statsTableBody.innerHTML = '';

      const statsData: { section: string; metric: string; value: any; description: string }[] = [];

      // Bytes Received Section
      statsData.push({
        section: 'bytes',
        metric: 'Total Bytes Received',
        value: Number(player.totalBytesReceived).toLocaleString(),
        description: 'The total amount of data received from the stream, measured in bytes.',
      });
      statsData.push({
        section: 'bytes',
        metric: 'Current Bitrate (bps)',
        value: Number(player.currentBitrate.toFixed(0)).toLocaleString(),
        description: 'The current data transfer rate, measured in bits per second (bps).',
      });

      // Video Data Section
      if (player.getVideoCodecInfo()) {
        statsData.push({
          section: 'video',
          metric: 'Video Codec',
          value: player.getVideoCodecInfo()?.codecName,
          description: 'The video compression format used in the stream.',
        });
        statsData.push({
          section: 'video',
          metric: 'Video Data Rate',
          value: player.getVideoCodecInfo()?.dataRate?.toFixed(0),
          description: 'Video Bitrate, the amount of video data transmitted per second, measured in kilobits per second (kbps).',
        });
        statsData.push({
          section: 'video',
          metric: 'Video Width',
          value: player.getVideoCodecInfo()?.width,
          description: 'The width of the video frame in pixels.',
        });
        statsData.push({
          section: 'video',
          metric: 'Video Height',
          value: player.getVideoCodecInfo()?.height,
          description: 'The height of the video frame in pixels.',
        });
      }

      // Audio Data Section
      if (player.getAudioCodecInfo()) {
        statsData.push({
          section: 'audio',
          metric: 'Audio Codec',
          value: player.getAudioCodecInfo()?.codecName,
          description: 'The audio compression format used in the stream (e.g., AAC).',
        });
        statsData.push({
          section: 'audio',
          metric: 'Audio Data Rate',
          value: player.getAudioCodecInfo()?.dataRate?.toFixed(0),
          description: 'Audio Bitrate, the amount of audio data transmitted per second, measured in kilobits per second (kbps).',
        });
        statsData.push({
          section: 'audio',
          metric: 'Audio Sample Rate',
          value: player.getAudioCodecInfo()?.sampleRate,
          description: 'The number of audio samples captured per second, measured in Hertz (Hz).',
        });
        statsData.push({
          section: 'audio',
          metric: 'Audio Channels',
          value: player.getAudioCodecInfo()?.channels,
          description: 'The number of audio channels (e.g., 2 for stereo, 1 for mono).',
        });
      }

      // Latency Section
      statsData.push({
        section: 'latency',
        metric: 'Late Frames Count',
        value: player.lateFramesCount,
        description: 'The number of video frames that arrived too late to be displayed on time.',
      });
      statsData.push({
        section: 'latency',
        metric: 'Average Lateness (ms)',
        value: player.getAverageLatenessMs().toFixed(2),
        description: 'The average delay of late frames beyond the acceptable threshold, measured in milliseconds.',
      });
      statsData.push({
        section: 'latency',
        metric: 'Average A/V Sync Offset (ms)',
        value: (player.getAverageAVSyncOffsetUs() / 1000).toFixed(2),
        description: 'The average difference in timing between the audio and video streams, measured in milliseconds.',
      });
      statsData.push({
        section: 'latency',
        metric: 'Max A/V Sync Offset (ms)',
        value: (player.avSyncMaxOffsetUs / 1000).toFixed(2),
        description: 'The maximum observed audio-video synchronization offset during the streaming session.',
      });

      statsData.forEach((stat) => {
        const row = document.createElement('tr');
        const metricCell = document.createElement('td');
        const valueCell = document.createElement('td');
        const descriptionCell = document.createElement('td');

        metricCell.textContent = stat.metric;
        valueCell.textContent = stat.value;
        descriptionCell.textContent = stat.description;

        valueCell.classList.add('value-column');

        row.appendChild(metricCell);
        row.appendChild(valueCell);
        row.appendChild(descriptionCell);

        switch (stat.section) {
          case 'bytes':
            row.classList.add('table-section-bytes');
            break;
          case 'video':
            row.classList.add('table-section-video');
            break;
          case 'audio':
            row.classList.add('table-section-audio');
            break;
          case 'latency':
            row.classList.add('table-section-latency');
            break;
        }

        statsTableBody.appendChild(row);
      });
    } catch (e) {
      console.error('onStatsUpdate error:', e);
    }
  }

  const playButton = getDOMElement<HTMLButtonElement>('play-button');
  if (playButton) {
    playButton.onclick = () => {
      let url = 'https://t2devteam-edge-eu-vu-ams-01.nanocosmos.de:4433/h5live/stream/stream.mp4';
      let constructedUrl = '';

      if (isIndexPage) {
        // ** Logic for index.html **

        const windowUrl = new URL(window.location.toString());
        const streamParam = windowUrl.searchParams.get('stream') || 'HX26g-Y65TP';
        const h3UrlParam = windowUrl.searchParams.get('h3Url');

        if (h3UrlParam) {
          try {
            const decodedH3Url = decodeURIComponent(h3UrlParam);
            const h3Url = new URL(decodedH3Url);

            if (h3Url.searchParams.has('stream')) {
              constructedUrl = h3Url.toString();
            } else {
              const streamValue = streamInputEl.value || streamParam;
              h3Url.searchParams.set('stream', streamValue);
              constructedUrl = h3Url.toString();
            }
          } catch (error) {
            console.error('Invalid h3Url parameter:', error);
            const selectedServerKey = h3ServerSelectEl.value;
            let serverUrl = '';
            if (selectedServerKey === 'custom') {
              serverUrl = customHostInputEl.value;
            } else {
              serverUrl = serverUrls[selectedServerKey];
            }
            const streamValue = streamInputEl.value || streamParam;
            const separator = serverUrl.includes('?') ? '&' : '?';
            constructedUrl = serverUrl + separator + 'stream=' + encodeURIComponent(streamValue);
          }
        } else if (h3ServerSelectEl && customHostInputEl && streamInputEl) {
          const selectedServerKey = h3ServerSelectEl.value;
          let serverUrl = '';
          if (selectedServerKey === 'custom') {
            serverUrl = customHostInputEl.value;
          } else {
            serverUrl = serverUrls[selectedServerKey];
          }
          const streamValue = streamInputEl.value || streamParam;
          const separator = serverUrl.includes('?') ? '&' : '?';
          constructedUrl = serverUrl + separator + 'stream=' + encodeURIComponent(streamValue);
        } else {
          constructedUrl = url + '?stream=' + encodeURIComponent(streamParam);
        }

        url = constructedUrl;
      } else {
        // ** Logic for demo.html **

        url = demoPageUrlToPlay;
      }

      play(url, canvasEl as HTMLCanvasElement);
    };
  }

  const pauseButton = getDOMElement<HTMLButtonElement>('pause-button');
  if (pauseButton) {
    pauseButton.onclick = () => {
      if (isIndexPage) {
        if (h3ServerSelectEl && customHostInputEl && streamInputEl) {
          h3ServerSelectEl.disabled = false;
          customHostInputEl.disabled = false;
          streamInputEl.disabled = false;
        }
      }

      pause();
    };
  }

  if (volumeInputEl && volumeOutputEl) {
    volumeInputEl.oninput = () => {
      setVolume(parseInt(volumeInputEl.value));
    };

    volumeInputEl.onchange = () => {
      setVolume(parseInt(volumeInputEl.value));
    };
  }

  function play(url: string, canvasEl: HTMLCanvasElement) {
    player.play(url, canvasEl);
  }

  function pause() {
    player.pause();
  }

  function setVolume(value: number) {
    player.setVolume(value);
    if (volumeInputEl) {
      volumeInputEl.value = value.toString();
    }
    if (volumeOutputEl) {
      volumeOutputEl.innerText = value.toString() + '%';
    }
  }

  function checkSupportedTechs(): boolean {
    return (
      typeof WebTransport !== 'undefined' &&
      typeof (window as any).VideoDecoder !== 'undefined' &&
      typeof (window as any).AudioDecoder !== 'undefined' &&
      typeof (window as any).AudioContext !== 'undefined'
    );
  }
}
